import React from "react";
import { Box } from "@mui/material";
import CrewBoard from "./CrewBoard";
import { Alert } from "@mui/material";
import { useSelector } from "react-redux";
import CustomButton from "../../../../components/common/button/CustomButton";

interface MainCrewPageProps {
  filteredData: any;
  isEditable?: boolean;
  handleClearViewers: () => void;
  isViewOnly?: boolean;
  isClearViewersPending?: boolean;
}

const MainCrewPage = ({
  filteredData,
  isEditable,
  handleClearViewers,
  isViewOnly,
  isClearViewersPending,
}: MainCrewPageProps) => {
  const { user } = useSelector((state: any) => state?.user);
  const { trackWorkerDetails } = useSelector(
    (state: any) => state.assignWorker,
  );

  const isOwner =
    user?.user?.roles?.some(
      (role: string) =>
        role.toUpperCase().includes("OWNER") ||
        role.toUpperCase().includes("TENANT"),
    ) ?? false;

  return (
    <>
      {!isEditable && !isViewOnly && (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Alert severity="info" sx={{ mb: 2, width: "100%" }}>
            {/* Optional chaining guard: avoids a crash if trackWorkerDetails is
                temporarily empty/null during a re-render */}
            The user {trackWorkerDetails[0]?.name} is already allocating. You
            may only view this page.
          </Alert>
          {isOwner && (
            <CustomButton
              sx={{ ml: 4, mb: 2, mr: 2, zIndex: 10, width: "150px" }}
              variant="outlined"
              title={isClearViewersPending ? "Clearing..." : "Clear Viewers"}
              disabled={isClearViewersPending}
              onClick={handleClearViewers}
            />
          )}
        </Box>
      )}
      <CrewBoard
        filteredData={filteredData}
        isEditable={isEditable}
        isViewOnly={isViewOnly}
      />
    </>
  );
};

export default MainCrewPage;
